import z from 'zod'

import { entitySchema } from '@/utility'

/** Additional data stored on user signup to manage malicious platform use */
export const signupMetaSchema = entitySchema
  .extend({
    email: z.string().optional(),
    ip: z.string().optional(),
    region: z.string().optional(),
    city: z.string().optional(),
    location: z.string().optional(),
  })
  .meta({ id: 'signup-meta' })

export type SignupMeta = z.infer<typeof signupMetaSchema>
